jQuery(function($){
  if ($('.video').length){
    $('.video').magnificPopup({
      type: 'iframe',
      iframe: {
        patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: '//www.youtube-nocookie.com/embed/%id%?autoplay=1'
          },
        },
        srcAction: 'iframe_src',
      }
    });
  }
});
